import axios from 'axios';

const token =  localStorage.getItem('login_token');
const hostname = window.location.hostname ;
let back ='';

if(process.env.VUE_APP_BASE_URL_PROD.includes(hostname)){    
    back=process.env.VUE_APP_API_BASE_PROD+process.env.VUE_APP_API_VERSION;
}
  
if(process.env.VUE_APP_BASE_URL_PREPROD.includes(hostname)){
back=process.env.VUE_APP_API_BASE_PREPROD+process.env.VUE_APP_API_VERSION
}
    
if(process.env.VUE_APP_BASE_URL_DEV.includes(hostname)){
    back=process.env.VUE_APP_API_BASE_DEV+process.env.VUE_APP_API_VERSION
}
  
if(process.env.VUE_APP_BASE_URL_DEV_LOCAL.includes(hostname)){
    back=process.env.VUE_APP_API_BASE_DEV_LOCAL+process.env.VUE_APP_API_VERSION    
}
  
if(process.env.VUE_APP_BASE_URL_SANDBOX.includes(hostname)){
    back=process.env.VUE_APP_API_BASE_SANDBOX+process.env.VUE_APP_SANDBOX    
}

// const baseDomain = 'https://apibroker.beta.imoney.africa'+process.env.VUE_APP_API_VERSION;
// const baseDomain = inject('back');


export const customHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`
};

export const baseUrl = `${back}`;

export default axios.create({
    baseUrl,
    headers: customHeaders
});

export const serializeQuery = query => {
    return Object.keys(query)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
        .join('&');
};